import { href } from "../router.js";
import { backLink, esc } from "../ui.js";
import type { View } from "./view.js";

export function notFoundView(message = "There's nothing at this address."): View {
  return {
    title: "Not found",
    html: `
      ${backLink(href.home(), "Standings")}
      <section class="card"><h2>Not found</h2><p class="hint">${esc(message)}</p></section>`,
  };
}
